export default "__VITE_ASSET__KFz6zAUh__"